import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlService } from '../../../../../environments/urlService';
import { Observable, map } from 'rxjs';
import { BudgetModel, BudgetModelWrapperDTO } from "../../pojo/bm-classes";
import { BmGeneralService } from "../general/bm-general-service";

@Injectable({
  providedIn: 'root',
})
export class BudgetModelBackendService {
  private readonly url: string;

  constructor(
    private http: HttpClient,
    private urlService: UrlService,
  ) {
    this.url = this.urlService.getFmsUrl() + 'budget-model';
  }

  get(modelUuid: string): Observable<BudgetModel> {
    return this.http.get<BudgetModel>(this.url + '/' + modelUuid, {
      withCredentials: true,
    });
  }

  getInitialModelData(orgUuid: string): Observable<BudgetModelWrapperDTO> {
    return this.http
      .get<BudgetModelWrapperDTO>(this.url + '/initial/' + orgUuid, {
      withCredentials: true,
    })
      .pipe(
        map((wrapper) => ({
          ...wrapper,
          selectorData: wrapper.selectorData.map((modelMiniData) => ({
            ...modelMiniData,
            selectorText: BmGeneralService.createSelectorText(modelMiniData),
          })),
        })),
      );
  }

  create(model: BudgetModel): Observable<BudgetModel> {
    return this.http.post<BudgetModel>(this.url, model, {
      withCredentials: true,
    });
  }

  update(model: BudgetModel): Observable<BudgetModel> {
    return this.http.put<BudgetModel>(this.url, model, {
      withCredentials: true,
    });
  }

  duplicate(modelUuid: string): Observable<BudgetModel> {
    return this.http.post<BudgetModel>(
      this.url + '/duplicate/' + modelUuid, null,
      { withCredentials: true },
    );
  }

  delete(modelUuid: string): Observable<void> {
    return this.http.delete<void>(this.url + '/' + modelUuid, {
      withCredentials: true,
    });
  }
}
